import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterPledgeCumGuaranteePageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='pledge_cum_guarantee_general'
        title='Pledge Cum Guarantee'
        activeTab='pledgeCumGuarantee'
        navConfig={null}
      />
    )
  }
}

export default MasterPledgeCumGuaranteePageSF
